
import "./Navbar.scss"
import { useSelector } from "react-redux";
import config from "react-global-configuration";
import notification from "../../assets/notification.svg"
import user from "../../assets/user.svg"
import arrow from "../../assets/arrow-black.svg"
import { useHistory } from "react-router";

const NavbarMini = () => {
    const company = useSelector((state) => state.companyData.company);
    const history = useHistory()

    return (
        <div className="MenuNavbarV4">
            <div className="MenuNavbarV4-inner"
                style={{ backgroundColor: company?.Style?.NavigationColor }}>
                <div className="MenuNavbarV4-inner-left">
                    <img className="MenuNavbarV4-inner-left-back"
                        onClick={() => {
                            history.goBack()

                        }} alt="" src={arrow} />
                    <img
                        className="MenuNavbarV4-inner-left-logo"
                        style={{ maxHeight: "48px" }}
                        src={config.get("companyLogo")}
                        draggable="false"
                    />
                </div>
                <div className="MenuNavbarV4-inner-right">
                    <div className="MenuNavbarV4-inner-right-icon">
                        <div className="MenuNavbarV4-inner-right-icon-ic">
                            <img alt="" src={notification} />
                        </div>
                        <div className="MenuNavbarV4-inner-right-icon-ic-prof">
                            <img alt="" src={user} />
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}
export default NavbarMini